import type { FaireProductEntity } from "../../entity_types/product";

export const p_7evb7nmnxw: FaireProductEntity = {
  token: "p_7evb7nmnxw",
  type: "product",
  name: "Flying Pig Stud Earrings",
  brandToken: "b_d5xrgr19y5",
  brandName: "Fable England",
  imageUrl:
    "https://cdn.faire.com/fastly/c5d09c2f3ccce93cec9e949858397198f355b2c2979e413ebbc34b321fe68211.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e9265946fa9e7cb1750a7f0e6deca78c1a56f9d7febc9e3dd3e501366b8afb21.jpeg",
    "https://cdn.faire.com/fastly/0935806724527d8539041efc8c42dff32df999f41080af4a2cf619055029ccc6.jpeg",
    "https://cdn.faire.com/fastly/e556bc4053f8e9eb603afb3814a4b3374317a08a3056f71204e8f58bcaefb07d.jpeg",
    "https://cdn.faire.com/fastly/4422d5307b766f66856389742b405885279c182ae9150550ccab86277f6a83a0.jpeg",
    "https://cdn.faire.com/fastly/1bbcc33075137cd84894dc871a53b8cd4b0271c34319cf1246481f4640640695.png",
  ],
  priceDollars: 17.5,
  description:
    "The Flying Pig Stud Earrings bring a touch of playful optimism to every day. Hand painted in soft pink enamel and finished with 22ct worn gold plating, these dainty studs remind us to keep a sense of wonder and light-hearted spirit in all we do. \n\nStyle: Stud earring\nColour: Gold and pink\nFinish: 22ct worn gold-plated\nFastening: Stainless steel posts with butterfly backs \nDetail: Delicate enamel finish \n\nStud: Approx. 9 mm (H) x 12 mm (W); (Approx. 0.35 in x 0.47 in) \n\n22ct worn gold-plated brass, zinc alloy, enamel; Earring posts: stainless steel\nCare: Wipe clean with a soft cloth\n\n",
  tags: [],
  msrpDollars: 43.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:39.894Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
